export enum RoleTypes {
    ADMIN = 'ADMIN',
    MANAGER = 'CLUB_MANAGER'
}